module.exports = __webpack_public_path__ + "img/携程_04.cc72ec61.jpg";